export function canApprove(checklist: boolean[]): boolean {
  return checklist.length > 0 && checklist.every(Boolean);
}
